// Client-side navigation for code outside React components (or where a hook
// isn't handy). Pushes the path and fires popstate, which BrowserRouter listens
// for, so the page changes without a full reload.
export const navigateTo = (path: string) => {
  const to = path.startsWith("/") ? path : `/${path}`;
  window.history.pushState(null, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
};
